module.exports = __webpack_public_path__ + "img/scan 8.78d82f31.jpg";